import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import styles from './_AccessorySlider.module.css';

export interface AccProps {
  accessories: Array<{
    toutContent?: any;
    img: {
      image: MediaType;
      altTag: string;
    };
  }>;
}

const AccessorySlider = ({ accessories }: AccProps) => {
  return (
    <ul className={styles.accessorySlider}>
      {accessories &&
        accessories.map(({ img, toutContent }, i) => (
          <li
            key={i}
            tabIndex={0}
            className="relative flex flex-col min-w-[21rem] h-[21rem] text-white
              mr-2 mb-6 bg-center focus:border-[3px] focus:border-brand-300
              focus-visible:border-[3px] focus-visible:border-brand-300"
            style={{
              backgroundImage: `linear-gradient(to top, rgba(16, 16, 16, 1), rgba(0, 0, 0, 0)), url('${buildImageSrc(img.image, 700, 1, 1)}')`,
            }}
          >
            <div className="p-6 absolute bottom-6">
              <ToutContent
                dark
                headingStyleVariant="h5"
                divider={!!toutContent?.description}
                {...toutContent}
                buttonSize="small"
                align="left"
              />
            </div>
          </li>
        ))}
    </ul>
  );
};

export default AccessorySlider;
